"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _FormTextbox = require("./FormTextbox");
Object.keys(_FormTextbox).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _FormTextbox[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _FormTextbox[key];
    }
  });
});